import Phaser from 'phaser';

/** Far outside any scene: where a cancelled touch is let go, so nothing is under it. */
const NOWHERE = -100_000;

/**
 * A cancelled touch presses nothing (lm-36t). When iOS takes over a swipe from the bottom edge
 * (going home, the app switcher), the page gets `touchcancel`, and Phaser treats that like a
 * finger lifted where it was: whatever button lay under the swipe got a "pointerup" and fired.
 * This moves a cancelled pointer far away before Phaser looks for what is under it, so no game
 * object is released on. Scene-wide pointerup listeners still hear it; they check
 * `pointer.wasCanceled` themselves (steering, menu page swipes).
 */
export function guardCancelledTouches(): void {
  type Cancel = (this: Phaser.Input.Pointer, touch: Touch, event: TouchEvent) => void;
  const proto = Phaser.Input.Pointer.prototype as unknown as { touchcancel: Cancel };
  // (Taken off the prototype and called with each pointer as `this`.)
  const original = proto.touchcancel;
  proto.touchcancel = function (this: Phaser.Input.Pointer, touch: Touch, event: TouchEvent) {
    original.call(this, touch, event);
    this.x = NOWHERE;
    this.y = NOWHERE;
    this.upX = NOWHERE;
    this.upY = NOWHERE;
    this.worldX = NOWHERE;
    this.worldY = NOWHERE;
  };
}
